import React from 'react';
import Languages from '../../../components/marketing/pageSections/home/Languages';
import TraductionTypes from '../../../components/marketing/pageSections/home/TraductionTypes';
import MySelf from '../../../components/marketing/pageSections/home/MySelf';
import HireTraductor from '../../../components/marketing/pageSections/home/Statistics';
import Testimonials from '../../../components/marketing/pageSections/home/Testimonials';
import Services from '../../../components/marketing/pageSections/home/Services';
import Statistics from '../../../components/marketing/pageSections/home/statistique';
import ContactInfo from '../../../components/marketing/pageSections/home/ContactInfo';

function Home(props) {
    return (
        <>
            <Services classe="block md:hidden" />
            <MySelf />
            {/* <Languages /> */}
            <Statistics />
               
            <TraductionTypes />
            <HireTraductor />
            <ContactInfo />
            {/*<Testimonials />*/}
        </>
    );
}

export default Home;